import { DestroyRef, Directive, ElementRef, inject, input, NgZone, OnInit } from '@angular/core';
import { EMPTY, fromEvent, switchMap } from 'rxjs';
import { ToastsService } from '../components/toasts/toasts.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  standalone: true,
  selector: '[appCopyToClipboard]'
})
export class CopyToClipboardDirective implements OnInit {
  private host = inject(ElementRef<HTMLElement>);
  private zone = inject(NgZone);
  private toast = inject(ToastsService);
  private destroyRef = inject(DestroyRef);

  appCopyToClipboard = input<string | null>(null);

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      fromEvent(this.host.nativeElement, 'click')
        .pipe(
          switchMap(() => {
            if (!this.appCopyToClipboard()) return EMPTY;
            return navigator.clipboard.writeText(this.appCopyToClipboard()!);
          }),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(() => this.toast.showSuccess('Copied!'));
    });
  }
}
